import { toDictionary } from '@/utils/array'
import { request } from '@/utils/request'

export function aggregateSurveyResults(surveys) {
    if (surveys.length === 0) {
        return null
    }

    const aggregate = {}

    surveys.forEach(survey => {
        for (const [key, value] of Object.entries(survey)) {
            if (value) {
                const a = (aggregate[key] ??= { count: 0, max: 1, min: 5, value: 0 })

                a.count++
                a.max = Math.max(a.max, value)
                a.min = Math.min(a.min, value)
                a.value += value
            }
        }
    })

    Object.values(aggregate).forEach(v => (v.value = v.value / v.count))

    return aggregate
}

export const InterviewService = {
    async listByReportId(reportId) {
        const content = await request.get(`/api/interviews/reports/${reportId}`)

        if (content.interviews) {
            const surveys = toDictionary(content.surveys, s => s.interviewId)
            const interviews = content.interviews
            interviews.forEach(i => {
                i.survey = surveys[i.id] ?? null
            })
            return interviews
        }

        return content
    },
    async get(interviewId) {
        const content = await request.get(`/api/interviews/${interviewId}`)

        if (content.interview) {
            const interview = content.interview
            interview.survey = content.survey ?? null
            return interview
        }

        return content
    },

    async highlight(interviewId, query) {
        const content = await request.get(`/api/interviews/${interviewId}/highlight`, { query })

        if (content.interview) {
            const interview = { ...content.interview, highlights: content.highlights }
            interview.survey = content.survey ?? null
            return interview
        }

        return content
    },

    getSurvey(interviewId) {
        return request.get(`/api/executive-surveys/${interviewId}`)
    },
}
